import {
  MaterialReactTable,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
} from "material-react-table";

import DatagridTooltipProvider from "./datagridTooltipProvider.js";
import { useState } from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { useRef } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/FilterAltOff";
import ClearSortingIcon from "@mui/icons-material/MobiledataOff";
import FileDownloadIcon from "@mui/icons-material/NoteAdd";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

import {
  mrtGetBodyRowSx,
  mrtGetBottomToolbarSx,
  mrtGetContainerSx,
  mrtGetPaperSx,
  mrtGetTableWrapperSx,
  mrtGetTopToolbarFlexSx,
} from "../../utils/helpers";

import constants from "../../assets/constants";
import { createNewPatientData, createNewReport } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import { formatIsoDateString, getReportOnlyFields } from "../../utils/helpers";
import { createOmniPaginationObject } from "../../utils/helpers";
import TextInputDialog from "../dialogs/textInputDialog";
import OmniGridButton from "../ui/omniGridButton";

const calculateColumns = () => {
  //default case
  let theReturn = [
    {
      accessorKey: "_id",
      header: "ID",
      size: 150,
      enableColumnFilterModes: false,
    },
    {
      accessorKey: "omniAudit.createdDate",
      enableColumnFilterModes: false,
      header: "Created",
      size: 125,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableColumnFilter: false,
      //custom conditional format and styling
      Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
    },
    {
      accessorKey: "omniData.familyName",
      header: "Last",
      size: 120,
      enableColumnFilterModes: false,
      enableSorting: false,
      grow: true,
    },
    {
      accessorKey: "omniData.givenName",
      header: "First",
      size: 120,
      enableColumnFilterModes: false,
      enableSorting: false,
      grow: true,
    },
    {
      accessorKey: "omniData.mobilePhone",
      header: "Phone",
      size: 100,
      enableColumnFilterModes: false,
      enableSorting: false,
    },
    {
      accessorKey: "omniData.email",
      header: "Email",
      enableColumnFilterModes: false,
      enableSorting: false,
      size: 150,
    },
  ];

  // let patientData = createNewPatientData();
  // for (var aProp in patientData) {
  //   if (aProp !== "demo") {
  //     let theVal = {
  //       accessorKey: `omniData.patientData.${aProp}`,
  //       header: capitalizeAllWords(aProp.replace("score", "").replace(/([A-Z]+)/g, " $1")),

  //       width: 150,
  //       muiTableHeadCellProps: {
  //         align: "center",
  //       },
  //       muiTableBodyCellProps: {
  //         align: "center",
  //       },
  //       enableColumnFilterModes: false,
  //       isVisible: false,
  //     };
  //     theReturn.push(theVal);
  //   }
  // }

  return theReturn;
};

const getInitialState = () => {
  let theReturn = {
    density: "compact",
    columnVisibility: {
      _id: false,
      "omniData.givenName": true,
      "omniData.familyName": true,
      "omniData.mobilePhone": false,
      "omniData.email": false,
    },
  };

  let patientData = createNewPatientData();
  for (var aProp in patientData) {
    if (aProp !== "demo") {
      theReturn.columnVisibility[`omniData.patientData.${aProp}`] = false;
    }
  }
  theReturn.columnVisibility["omniData.patientData.scorePHQ9"] = true;
  theReturn.columnVisibility["omniData.patientData.scoreIndependentFunction"] = true;

  return theReturn;
};

export const SurveyPatients = props => {
  const {
    patientODMs,
    onEditPatient = null,
    // onViewPatient = null,
    onRequestNewPage = null,
    isLoading = false,
    patientPagination = createOmniPaginationObject,
  } = props;

  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));
  const tableContainerRef = useRef(null); //we can get access to the underlying TableContainer element and react to its scroll events

  const columns = useMemo(() => calculateColumns(), []);
  const initialState = useMemo(() => getInitialState(), []);

  const [showReportNameInput, setShowReportNameInput] = useState(null);

  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    if (patientPagination != null) {
      setPagination({
        pageIndex: patientPagination.pageIndex - 1,
        pageSize: patientPagination.pageSize,
      });
      setRowCount(patientPagination.totalItems);
    }
  }, [patientPagination]);

  const [sorting, setSorting] = useState([]);

  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    let newQuery = {};
    columnFilters.forEach(element => {
      newQuery[element.id] = {
        "#regex": `${element.value}`,
        "#options": "i",
      };
    });

    let newSorting = {};
    sorting.forEach(element => {
      newSorting[element.id] = element.desc ? -1 : 1;
    });

    if (
      patientPagination &&
      (pagination.pageIndex + 1 !== patientPagination.pageIndex ||
        pagination.pageSize !== patientPagination.pageSize ||
        JSON.stringify(pagination.query) !== JSON.stringify(columnFilters))
    ) {
      let newPage = createOmniPaginationObject(patientPagination);
      newPage.pageIndex = pagination.pageIndex + 1;
      newPage.pageSize = pagination.pageSize;
      newPage.query = newQuery;
      newPage.sort = newSorting;

      onRequestNewPage(newPage);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnFilters, sorting, pagination.pageIndex, pagination.pageSize]);

  if (patientODMs == null) {
    return <Fragment></Fragment>;
  }

  return (
    <DatagridTooltipProvider>
      <Box sx={mrtGetTableWrapperSx(0, !patientODMs?.length)}>
      <MaterialReactTable
      layoutMode="grid"
      muiTableBodyRowProps={{ sx: mrtGetBodyRowSx() }}
      columns={columns}
      data={patientODMs}
      initialState={initialState}
      defaultColumn={{
        minSize: 20, //allow columns to get smaller than default
        maxSize: 9001, //allow columns to get larger than default
        size: 100, //make columns wider by default
        grow: false,
      }}
      state={{
        columnFilters,
        isLoading,
        pagination,
        sorting,
      }} //pass our managed row selection state to the table to use
      //pagination
      manualPagination={true}
      onColumnFiltersChange={setColumnFilters}
      onPaginationChange={setPagination}
      //header
      enableColumnActions={false}
      enableStickyHeader={true}
      manualSorting
      manualFiltering
      onSortingChange={setSorting}
      enableColumnFilterModes={true}
      filterFns={{
        customFilterFn: (row, id, filterValue) => {
          return row.getValue(id) === filterValue;
        },
      }}
      muiTableHeadCellFilterTextFieldProps={{
        sx: {
          "& .MuiInputBase-input": { padding: "6px" },

          "& .MuiInputBase-root": { paddingRight: "0px" },
          "& .MuiSelect-iconOutlined": { marginRight: "0.75rem" },
          width: "100%",
        },
        variant: "outlined",
      }}
      //row
      enableRowActions={true}
      enableRowSelection={false}
      getRowId={originalRow => originalRow._id}
      rowCount={rowCount}
      positionToolbarAlertBanner="bottom"
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      renderTopToolbarCustomActions={() => <Box sx={{ minHeight: "40px" }} />}
      muiTopToolbarProps={{
        sx: {
          ...mrtGetTopToolbarFlexSx(),
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.secondary.main,
        },
      }}
      muiBottomToolbarProps={{
        sx: mrtGetBottomToolbarSx(theme),
      }}
      muiTablePaperProps={{
        sx: mrtGetPaperSx(),
      }}
      muiTableContainerProps={{
        ref: tableContainerRef, //get access to the table container element
        sx: mrtGetContainerSx(theme, mobileLayout),
      }}
      muiTableProps={{
        sx: {
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.main,
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: alpha(theme.palette.commonground.contrastText, 0.25),
          color: theme.palette.commonground.contrastText,
        },
      }}
      renderRowActions={({ row }) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: "2px",
            padding: 0,
          }}
        >
          <OmniGridButton
            key="edit"
            sx={{ ...(onEditPatient == null && { display: "none" }) }}
            onClick={() => {
              onEditPatient(row.original);
            }}
            icon={<EditIcon fontSize="small" />}
          />
        </Box>
      )}
      renderToolbarInternalActions={({ table }) => (
        <Box>
          {sorting.length > 0 && (
            <Tooltip title="Clear All Sorting" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setSorting([]);
                }}
              >
                <ClearSortingIcon />
              </IconButton>
            </Tooltip>
          )}
          {columnFilters.length > 0 && (
            <Tooltip title="Clear All Filters" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setColumnFilters([]);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}
          {/* eslint-disable react/jsx-pascal-case*/}
          {/* <MRT_ToggleGlobalFilterButton table={table} /> */}
          <MRT_ToggleFiltersButton table={table} />
          <MRT_ShowHideColumnsButton table={table} />
          <MRT_ToggleFullScreenButton table={table} />
          {/* eslint-enablereact/jsx-pascal-case */}
          <Tooltip title="Export Via Report" arrow>
            <IconButton
              onClick={() => {
                setShowReportNameInput(`${new Date().toJSON().slice(0, 10)}-Candidates-`);
              }}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>

          {showReportNameInput && (
            <TextInputDialog
              dialogTitle="Report Name"
              dialogMessage={"Please name your report"}
              inputLabel={`${"Report Name"}`}
              defaultValue={showReportNameInput}
              open={showReportNameInput}
              onAccept={theText => {
                /// do it!
                //create the report ..

                let theReport = createNewReport();
                theReport.omniData.name = theText;
                theReport.omniData.reportType = constants.reportTypeEnums.users;

                theReport.omniData["userType"] = "patient";

                theReport.omniData["onlyFields"] = getReportOnlyFields(
                  constants.reportTypeEnums.users,
                  true,
                );
                let theQuery = patientPagination.query;

                theReport.omniData["query"] = theQuery;
                delete theReport.omniData.dateBefore;
                delete theReport.omniData.dateAfter;

                props.createReportRequest(theReport);

                setShowReportNameInput(false);
              }}
              onClose={() => {
                setShowReportNameInput(false);
              }}
            />
          )}
        </Box>
      )}
      />
      </Box>
    </DatagridTooltipProvider>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  createReportRequest: AdminSessionActions.createReportRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyPatients);
